export default class InteractiveMapEnum {
    static INTERACTIVE_MAP = ".wpet-block-interactive-map"
    static INTERACTIVE_MAP_WRAPPER = `${InteractiveMapEnum.INTERACTIVE_MAP} [data-wpet-map]`
    static INTERACTIVE_MAP_INFOBOX_MOBILE = '[data-wrapper="wpet-interactive-map-infobox-mobile"]'
}
